import React, { Component } from "react"
// import * as matrix from "matrix-mab"
import * as haphazard from "haphazard"
import * as nary from "nary-tree-mab"

export default class RandomPathsGenerator extends Component {
    state = {
        width:  400,
        height: 400,
        seed:   1234562
    }

    editable =  {
        width: (v) => true,
        height: (v) => true,
        seed: (v) => true
    }

    draw_rivers(e) {
        e.preventDefault()
        const ctx = document.getElementById("custom_paths").getContext("2d")
        ctx.clearRect(0, 0, this.state.width, this.state.height)
        let start_x = Math.floor(this.state.width/2)
        let start_y = 0

        const rand = new haphazard.BBS(this.state.seed)

        const tree = new Rivers()
        const root = tree.create_node(null, {x:start_x, y:start_y}, [])

        const max_y = 70;
        const max_x = 30;
        let current_depth = 0
        const max_depth = 9
        const max_children = 3

        build_absolutely_random_branches(
            root,
            max_y, max_x,
            current_depth, max_depth,
            max_children,
            rand
        )

        draw_path(ctx, root)
    }

    draw_rivers_binary(e) {
        e.preventDefault()
        const ctx = document.getElementById("custom_paths").getContext("2d")
        ctx.clearRect(0, 0, this.state.width, this.state.height)
        let start_x = Math.floor(this.state.width/2)
        let start_y = 0

        const rand = new haphazard.BBS(this.state.seed)

        const tree = new Rivers()
        const root = tree.create_node(null, {x: start_x, y: start_y}, [])

        const max_y = 90;
        const max_x = 30;
        let current_depth = 0
        const max_depth = 20
        const first_node_data = {
            x: this.state.width/4 + get_random_int(rand, this.state.width/2),
            y: 20 + get_random_int(rand, max_y)
        }
        const first_node = root.add_child(first_node_data)

        build_branches_binary(
            first_node,
            max_x, max_y,
            current_depth, max_depth,
            rand,
            {
                "start_x": 75,
                "end_x": this.state.width - 75,
                "scene_x": this.state.width,
                "scene_y": this.state.height
            }
        )

        draw_path(ctx, tree.root())
    }


    change(e) {
        if (e.target.name in this.editable) {
            let value = e.target.value
            // document.getElementById("custom_map")[e.target.name] = e.target.value
            if (isNaN(parseInt(value, 10))) {
                value = 0
            }

            if (typeof this.editable[e.target.name] !== "function") {
                throw new Error("the 'editable' should be a distpach map: check your code")
            }

            return this.setState({
                [e.target.name]: parseInt(value, 10)
            })
        }
    }

    render() { return(

<form className="random_paths_form">
<div className="form_controls">
    <div className="form_element_size">
    <label htmlFor="width">Width</label>
    <input type="text" name="width" id="width"
            value={this.state.width}
            onChange={ (e) => this.change(e)}
        />
    <br/>
    <label htmlFor="size">Height</label>
    <input type="text" name="height" id="height"
            value={this.state.height}
            onChange={ (e) => this.change(e)}
        />
    </div>

    <div className="form_element_seed">
    <label htmlFor="seed">Seed</label>
    <input type="text" name="seed" id="seed"
        value={this.state.seed}
        onChange={ (e) => this.change(e)}
    />
    </div>

    <button onClick={(e) => this.draw_rivers(e)}>Draw rivers random</button>
    <button onClick={(e) => this.draw_rivers_binary(e)}>Draw rivers binary</button>
</div>
<div className="paths_container">
    <canvas id="custom_paths"
        height={this.state.height}
        width={this.state.width}>
    </canvas>
</div>
</form>
    )}
}


function get_random_int(rand, max) {
    return (rand.next() % max) + 1
}

function draw_path(ctx, node) {
    const children = node.get_children()
    children.forEach(
        function(item, index) {
            const gradient = ctx.createLinearGradient(node.data.x, node.data.y, item.data.x, item.data.y)
            gradient.addColorStop(0, "red")
            gradient.addColorStop(1, "green")
            ctx.strokeStyle = gradient
            ctx.beginPath()
            ctx.moveTo(node.data.x, node.data.y)
            ctx.lineTo(item.data.x, item.data.y)
            ctx.stroke()
            ctx.closePath()
            draw_path(ctx, item)
        }
    )
}

class Rivers extends nary.NaryTree {

    check_for_intersections(
        start_x, start_y,
        end_x, end_y
    ) {
        for ( let i = 1; i < this.nodes_list.size; i++) {
            if (lines_intersect(
                    this.node(i),
                    start_x, start_y,
                    end_x, end_y
                )
            ) {
                return true
            }
        }
    }
}

function lines_intersect(
    node,
    start_x, start_y,
    end_x, end_y
) {
    const slope_new = (end_y - start_y) / (end_x - start_x)
    const slope_parent =
        (node.parent().data.y - node.data.y)
        /
        (node.parent().data.x - node.data.x)

    const x =
     (start_y - start_x*slope_parent - start_y + start_x*slope_new)
     /
     (slope_new - slope_parent)

    if ( x
        && x >= Math.min(node.parent().data.x, node.data.x)
        && x <= Math.max(node.parent().data.x, node.data.x)
    ) {
        return true
    }
    return false
}


function build_branches_binary(
    node,
    max_x, max_y, //
    current_depth, max_depth,
    rand,
    front // {start_x, end_x}
) {
    if (current_depth >= max_depth) {
        return null
    }
    current_depth++
    const available_first = Math.floor( (front.end_x - front.start_x)/2 )
    const available_second = front.end_x - available_first

    if (available_first < 10) {
        return null // too narrow, don't go further
    }
    const start_x_first = front.start_x
    const start_x_second = start_x_first + available_first
    const end_x_first = start_x_first + get_random_int(rand, available_first)
    const node_x_first = start_x_first + get_random_int(rand, end_x_first - Math.floor(end_x_first/3))
    const y_first = node.data.y + 5 + get_random_int(rand, max_y)

    const child_first = node.add_child(
        {
            x: node_x_first,
            y: y_first
        }
    )

    build_branches_binary(
        child_first,
        max_x, max_y,
        current_depth, max_depth,
        rand,
        {start_x: start_x_first, end_x: end_x_first}
    )

    // too narrow space for the second river, don't continue
    if (available_second < 10) {
        return null
    }

    // const start_x_second = end_x_first + 1
    const end_x_second = front.end_x
    const random_change = get_random_int(rand, ( available_second - Math.floor(available_second/3) ) )
    const node_x_second = start_x_second + 5 + random_change

    if (node_x_second > front.end_x) {
        return null
    }

    const y_second = node.data.y + 5 + get_random_int(rand, max_y)


    const child_second = node.add_child(
        {
            x: node_x_second,
            y: y_second
        }
    )

    build_branches_binary(
        child_second,
        max_x, max_y,
        current_depth, max_depth,
        rand,
        {start_x: start_x_second, end_x: end_x_second}
    )
}

function build_absolutely_random_branches(
    node,
    max_y, max_x,
    current_depth, max_depth,
    max_children,
    rand
) {
    if (current_depth >= max_depth) {
        return null
    }

    current_depth++
    const new_children_count = 2 // get_random_int(max_children)
    let counter = 0
    let tries = 0
    while (counter < new_children_count) {

        const direction =rand.next() % 2 === 1 ? -1 : 1;
        const start_x = node.data.x
        const start_y = node.data.y
        const end_x = node.data.x + direction * get_random_int(rand, max_x)
        const end_y = node.data.y + get_random_int(rand, max_y)

        if (
            true === node.tree().check_for_intersections(
                start_x, start_y,
                end_x, end_y
            )
        ) {
            if (tries > 20) {
                break
            }
            tries++
            continue
        }

        const child = node.add_child(
            {
                x: end_x,
                y: end_y
            }
        )
        counter++
        build_absolutely_random_branches(
            child,
            max_x, max_y,
            current_depth, max_depth,
            max_children,
            rand
        )
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/util/RandomPathsGenerator.js